import React from 'react'
import { Steps } from 'antd-mobile-v5'
import { WhiteSpace } from 'antd-mobile'
import { useIntl } from 'react-intl'

const { Step } = Steps

const StepStatus = ({ desc, note, status }) => {
  const { formatMessage } = useIntl()
  return (
    <>
      <WhiteSpace size="xl" />
      <Steps
        current={1}
        direction="vertical"
        style={{
          '--title-font-size': '17px',
          '--description-font-size': '15px',
          '--indicator-margin-right': '12px',
          '--icon-size': '22px',
        }}
      >
        <Step
          title={formatMessage({ id: 'form-current-status' }) + desc}
          description={note ? formatMessage({ id: 'form-not-approved-reason' }) + note : ''}
          status={status || 'finish'}
        />
      </Steps>
      <WhiteSpace size="xl" />
    </>
  )
}

export default StepStatus
